import React, { useState, useEffect } from "react";
import { Box, CardContent, Tab, Tabs, Typography } from "@mui/material";
import { StyledCard } from "../../assets/styled-components/StyledCard";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import { ErrorChips, SuccessChips } from "../../assets/styled-components/chips";
import utilities from "../../utility/utilities";

const TotalWorkRequestList = ({ responseFem, responseBem }) => {
  // Function to set and format data based on the selected response
  const setData = (response) => {
    return response?.totalWorkRequestLists?.map((item) => {
      return {
        ...item,
        deptworkrequestdate: utilities.formatDate({
          dateString: item.deptworkrequestdate,
          format: "dd/MM/yyyy",
          dbdate: true,
        }),
      };
    });
  };

  const colDef = [
    { field: "assetNo", headerName: "Asset No", minWidth: 120 },
    {
      field: "deptworkrequestno",
      headerName: "Work Request No",
      minWidth: 170,
    },
    {
      field: "deptworkrequestStatus",
      headerName: "Status",
      minWidth: 150,
      cellRenderer: (params) => {
        if (params.value === "Open") {
          return <ErrorChips label={params.value} />;
        } else {
          return <SuccessChips label={params.value} />;
        }
      },
    },
    {
      field: "deptworkrequestdate",
      headerName: "Work Request Date",
      minWidth: 200,
    },
  ];

  const [rowData, setRowData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [selectedTab, setSelectedTab] = useState(0);
  // Handle tab change event
  const handleTabChange = (_event, newValue) => {
    setSelectedTab(newValue);
  };

  // Update row data whenever the selected tab changes
  useEffect(() => {
    if (selectedTab === 0 && responseFem) {
      // If "Fems" tab is selected, set data from responseFem
      setRowData(setData(responseFem));
    } else if (selectedTab === 1 && responseBem) {
      // If "Bems" tab is selected, set data from responseBem
      setRowData(setData(responseBem));
    }
  }, [selectedTab, responseFem, responseBem]);

  return (
    <>
      <StyledCard>
        <CardContent>
          <Typography
            mb={1.5}
            variant="h5"
            fontWeight={700}
            color={"text.primary"}
          >
            Total Work Request
          </Typography>

          {/* Tabs */}
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            aria-label="Total Work Request"
          >
            <Tab label="FEMS" />
            <Tab label="BEMS" />
          </Tabs>

          <Box mt={2}>
            {/* CustomAgGrid component with dynamic rowData based on the selected tab */}
            <CustomAgGrid
              columns={colDef}
              rows={rowData}
              gridApi={gridApi}
              setGridApi={setGridApi}
              pagination={false}
              height={260}
              disableFilter={true}
            />
          </Box>
        </CardContent>
      </StyledCard>
    </>
  );
};

export default TotalWorkRequestList;
